import { render, staticRenderFns } from "./FilesBlock.vue?vue&type=template&id=6de0c7c2&scoped=true"
import script from "./FilesBlock.vue?vue&type=script&lang=js"
export * from "./FilesBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de0c7c2",
  null
  
)

export default component.exports